import { Component, inject } from "@angular/core";
import { DialogRef } from "@progress/kendo-angular-dialog";

@Component({
    selector: "wk-cancel-confirmation",
    templateUrl: "./cancel-confirmation.component.html",
    standalone: false,
    host: {
        "(document:keydown.escape)": "handleEsc()",
    },
})
export class CancelConfirmationComponent {
    private ref = inject(DialogRef);

    constructor() {}

    handleEsc() {
        this.ref.close();
    }
}
